<template>
  <div>
    <div v-if="hide" @click="hideHandler">
      {{ hideText }} <a-icon type="eye" class="hide-icon" ></a-icon>
    </div>
    <div v-else>
      {{ text }} 
      <!-- <a-icon type="eye-invisible" @click="hideHandler"></a-icon> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'Hide',
  props: {
    text: {
      type: String,
      default: ''
    },
    hideText: {
      type: String,
      default: '****'
    }
  },
  data() {
    return {
      hide: true
    };
  },
  methods: {
    hideHandler() {
      this.$emit('change', this.hide);
      this.hide = !this.hide;
    }
  }
};
</script>
<style lang="less" scoped>
.hide-icon {
  color:dodgerblue
}
</style>